<template>
  <div class="document-card-actions-rs">
    <NrIconButton
      v-if="canSeeChangeVisibilityAction"
      aria-label="Change visibility"
      :icon="{ name: 'eye', type: 'regular' }"
      variant="minimal-neutral"
      @click="$emit('on-visibility', id)"
    />

    <NrIconButton
      v-if="canSeeDownloadAction"
      aria-label="Download"
      variant="minimal-neutral"
      :icon="{ name: 'download', type: 'regular' }"
      @click="$emit('on-download', id)"
    />

    <NrIconButton
      v-if="canSeeMoreActions"
      aria-label="Menu"
      :aria-expanded="showMoreItems"
      :aria-controls="`document-card-show-more-${id}`"
      :icon="{ name: 'ellipsis-h', type: 'regular' }"
      variant="minimal-neutral"
      @click="showMore"
    />

    <div
      v-if="canSeeMoreActions"
      v-show="showMoreItems"
      :id="`document-card-show-more-${id}`"
      class="show-more-dropdown"
    >
      <div v-if="canSeeMoveToFolderAction">
        <NrButton
          class="show-more-action-button"
          variant="minimal-neutral"
          @click="$emit('on-move', id)"
        >
          <NrIcon name="folder" />
          <span>Move to folder</span>
        </NrButton>
      </div>

      <div v-if="canSeeRedactAction">
        <NrButton
          class="show-more-action-button"
          variant="minimal-neutral"
          @click="$emit('on-redact', id)"
        >
          <NrIcon name="wrench" />
          <span>Redact file</span>
        </NrButton>
      </div>

      <div v-if="canSeeRenameAction">
        <NrButton
          class="show-more-action-button"
          variant="minimal-neutral"
          @click="$emit('on-edit', id)"
        >
          <NrIcon name="pencil-alt" />
          <span>Rename file</span>
        </NrButton>
      </div>

      <div v-if="canSeeDeleteAction">
        <NrButton
          class="show-more-action-button"
          variant="minimal-neutral"
          @click="$emit('on-delete', id)"
        >
          <NrIcon name="trash-alt" />
          <span>Delete file</span>
        </NrButton>
      </div>
    </div>
  </div>
</template>

<script>
import NrIcon from '@nextrequestco/components/src/components/NrIcon'
import NrButton from '@nextrequestco/components/src/components/NrButton/nr-button'
import NrIconButton from '@nextrequestco/components/src/components/NrIconButton'

export default {
  name: 'DocumentCard',
  components: { NrIcon, NrButton, NrIconButton },
  props: {
    highlight: {
      type: String,
      default: 'default'
    },
    id: {
      type: Number
    },
    canSeeDownloadAction: {
      type: Boolean,
      default: false
    },
    canSeeChangeVisibilityAction: {
      type: Boolean,
      default: false
    },
    canSeeDeleteAction: {
      type: Boolean,
      default: false
    },
    canSeeMoveToFolderAction: {
      type: Boolean,
      default: false
    },
    canSeeRedactAction: {
      type: Boolean,
      default: false
    },
    canSeeRenameAction: {
      type: Boolean,
      default: false
    },
    disabled: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      showMoreItems: false
    }
  },
  computed: {
    canSeeMoreActions() {
      return (
        this.canSeeMoveToFolderAction ||
        this.canSeeRedactAction ||
        this.canSeeRenameAction ||
        this.canSeeDeleteAction
      )
    }
  },
  methods: {
    showMore() {
      this.showMoreItems = !this.showMoreItems
      this.$emit('show-more')
    },
    handleBlur() {
      setTimeout(() => {
        this.showMoreItems = false
      }, 200)
    }
  }
}
</script>

<style lang="scss">
.document-card-actions-rs {
  position: relative;
  display: flex;
  align-items: center;
  justify-content: flex-end;
  align-self: center;
  .show-more-dropdown {
    background: white;
    position: absolute;
    z-index: 2;
    top: calc(100% + 8px);
    right: 0;
    border: 1px solid #d8d8df;
    border-radius: 4px;
    width: 170px;
    .show-more-action-button {
      display: inline-flex;
      text-decoration: none;
      padding: 4px;
      width: 100%;
      .nr-icon {
        margin-top: 4px;
        margin-right: 4px;
      }
    }
  }
}
</style>
